import styled from "styled-components";

export const StyledMatchListPromo = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  padding: 16px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.rgba.white_240};
  box-sizing: border-box;
  margin: 12px auto 0;

  .mls-c-match-promo__promo-link-button {
    margin-top: 12px;
  }

  .mls-c-match-promo__support-compact {
    width: 218px;

    .mls-c-match-promo__support-compact__display-text {
      width: 134px;
    }

    .mls-c-support-copy__sponsor-logo {
      max-width: 64px;
      max-height: 28px;

      img {
        width: 100%;
        height: 28px;
      }
    }
  }
`;

export const StyledMatchPromoWrapper = styled.div`
  flex: 1;
  width: 100%;
`;

export const StyledSupportCopyCompactPromoWrapper = styled.div`
  flex: 1;
`;

export const StyledMatchListPromoDivider = styled.div`
  width: 100%;
  margin: 14px auto;
  border-top: 1px solid ${({ theme }) => theme.rgba.black_33_1};
`;

export const StyledPromoMiscWrapper = styled.div`
  width: 100%;

  a:first-child {
    .mls-c-match-promo__promo-link-button {
      margin-top: 0px;
    }
  }
`;

export const StyledMatchPromoLinksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .mls-c-match-promo__promo-link {
    margin-top: 4px;
  }

  .mls-c-match-promo__promo-link:first-child {
      margin-top: 0px;
  }
`;
